import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Select, TextArea, TextInput } from 'components/Form'
import {
    createApiRecord,
    updateApiRecord,
} from 'services/FormulaTemplateService'
import { useDispatch, useSelector } from 'react-redux'
import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import {
    getTransportProviderData,
    getTransportProviderServiceData,
} from 'store/data/dataSlice'
import { Upload } from 'components/Ui'
import { HiOutlineCloudUpload } from 'react-icons/hi'
injectReducer('formulaTemplate', reducer)

const Create = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const role = useSelector((state) => state.auth.user.groups)

    const validationSchema = Yup.object().shape({
        company: Yup.number().required('Please select company'),
        client: Yup.number().nullable(),
        transport_provider: Yup.number().required(
            'Please select transport provider',
        ),
        service: Yup.number().nullable(),
        note: Yup.string().required('Note Required'),
        formula: Yup.string().when([], {
            is: () => role === 'super-user',
            then: (schema) => schema.required('Please enter formula'),
            otherwise: (schema) => schema.notRequired(),
        }),
    })

    const {
        companyData,
        clientCompanyData,
        transportProviderData,
        transportProviderServiceData,
    } = useSelector((state) => state.listData)
    const { view, record, loading } = useSelector(
        (state) => state.formulaTemplate.data,
    )

    useEffect(() => {
        if (id) {
            fetchData(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchData = (id) => dispatch(getRecord(id))

    const handleDiscard = () => navigate('/master-data/formula-template')

    const handleSubmit = (values, setSubmitting) => {
        setSubmitting(true)
        if (id) {
            updateApiRecord(id, values)
                .then(() => {
                    Success('Updated Successfully!')
                    handleDiscard()
                    // dispatch(getCompanyData())
                    setSubmitting(false)
                })
                .catch((error) => {
                    setSubmitting(false)
                    return error
                })
        } else {
            createApiRecord(values)
                .then(() => {
                    Success('Created Successfully!')
                    handleDiscard()
                    // dispatch(getCompanyData())
                    setSubmitting(false)
                })
                .catch((error) => {
                    setSubmitting(false)
                    return error
                })
        }
    }

    if (loading) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    Formula
                </h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-lg border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                            {id
                                ? 'Update Formula'
                                : role === 'super-user'
                                  ? 'Add New Formula'
                                  : 'Send Request for New Formula'}
                        </h3>
                        {role !== 'super-user' && (
                            <p>
                                Contact the Super Admin to request the addition
                                of a new formula template. Fill out the form
                                with the necessary details and submit it.
                            </p>
                        )}
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={id ? record : view}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                handleSubmit(values, setSubmitting)
                            }}
                        >
                            {({ values, touched, errors, isSubmitting }) => (
                                <Form>
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-6">
                                        <Field name="company">
                                            {({ field, form }) => (
                                                <Select
                                                    options={companyData}
                                                    label="Company"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="company"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.company &&
                                                        touched.company
                                                    }
                                                    message={errors.company}
                                                    value={values?.company}
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                        form.setFieldValue(
                                                            'client',
                                                            '',
                                                        )
                                                        form.setFieldValue(
                                                            'transport_provider',
                                                            '',
                                                        )
                                                        form.setFieldValue(
                                                            'service',
                                                            '',
                                                        )
                                                        dispatch(
                                                            getTransportProviderData(
                                                                {
                                                                    company:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            ),
                                                        )
                                                        dispatch(
                                                            getTransportProviderServiceData(
                                                                {
                                                                    company:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            ),
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="client">
                                            {({ field, form }) => (
                                                <Select
                                                    options={clientCompanyData?.filter(
                                                        (item) =>
                                                            item?.client &&
                                                            item?.company?.id.toString() ===
                                                                values?.company,
                                                    )}
                                                    label="Client Company"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="client"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.client &&
                                                        touched.client
                                                    }
                                                    message={errors.client}
                                                    value={values?.client}
                                                    disabled={!values?.company}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="transport_provider">
                                            {({ field, form }) => (
                                                <Select
                                                    options={transportProviderData?.filter(
                                                        (item) =>
                                                            item.type ===
                                                            'Aggregator',
                                                    )}
                                                    label="Transport Provider"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="transport_provider"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.transport_provider &&
                                                        touched.transport_provider
                                                    }
                                                    message={
                                                        errors.transport_provider
                                                    }
                                                    value={
                                                        values?.transport_provider
                                                    }
                                                    disabled={!values?.company}
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="service">
                                            {({ field, form }) => (
                                                <Select
                                                    options={
                                                        transportProviderServiceData
                                                    }
                                                    label="Transport Provider Service"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="service"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.service &&
                                                        touched.service
                                                    }
                                                    message={errors.service}
                                                    value={values?.service}
                                                    disabled={!values?.company}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        {role === 'super-user' ? (
                                            <Field name="formula">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Formula"
                                                        name="formula"
                                                        error={
                                                            errors.formula &&
                                                            touched.formula
                                                        }
                                                        message={errors.formula}
                                                        value={values?.formula}
                                                        onChange={(e) =>
                                                            form.setFieldValue(
                                                                field.name,
                                                                e.target.value,
                                                            )
                                                        }
                                                    />
                                                )}
                                            </Field>
                                        ) : null}
                                        <Field name="note">
                                            {({ field, form }) => (
                                                <TextArea
                                                    label="Note"
                                                    name="note"
                                                    className="md:col-span-6"
                                                    error={
                                                        errors.note &&
                                                        touched.note
                                                    }
                                                    message={errors.note}
                                                    value={values?.note}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        {role !== 'super-user' ? (
                                            <Field name="picture">
                                                {({ field, form }) => (
                                                    <Upload
                                                        className="cursor-pointer md:col-span-6"
                                                        onChange={(files) => {
                                                            form.setTouched(
                                                                {},
                                                                false,
                                                            )
                                                            form.setFieldValue(
                                                                field.name,
                                                                files[0],
                                                            )
                                                        }}
                                                        onFileRemove={(files) =>
                                                            form.setFieldValue(
                                                                field.name,
                                                                files[0],
                                                            )
                                                        }
                                                        showList={false}
                                                        uploadLimit={1}
                                                        tip={
                                                            <p className="mt-2">
                                                                jpeg or png only
                                                            </p>
                                                        }
                                                        accept="image/jpeg, image/png"
                                                    >
                                                        <Button
                                                            type="button"
                                                            icon={
                                                                <HiOutlineCloudUpload />
                                                            }
                                                        >
                                                            Upload Image
                                                        </Button>
                                                    </Upload>
                                                )}
                                            </Field>
                                        ) : null}
                                        {values?.picture ? (
                                            <div>
                                                <label
                                                    className={`block mb-1 font-medium text-black dark:text-white`}
                                                >
                                                    {'Image'}
                                                </label>
                                                <div className="flex items-center justify-center p-3 border border-gray-400 rounded-md">
                                                    <img
                                                        src={
                                                            id
                                                                ? `http://3.24.103.169:8000${values.picture}` ??
                                                                  '#'
                                                                : values.picture
                                                                  ? URL.createObjectURL(
                                                                        values.picture,
                                                                    )
                                                                  : '#'
                                                        }
                                                        alt="error"
                                                    ></img>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                            disabled={isSubmitting}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Create
